import {Student, TableRow} from "../../classroomReport/components/ClassroomStandardsReport";
import {texteReport} from "../../testReport/utils/textReport";

export const getLevel = (score: number) => {
    if (score >= 9) {
        return "Avansat";
    } else if (score >= 7) {
        return "Consolidat";
    } else if (score >= 5){
        return "De bază";
    } else {
        return "În dificultate";
    }
}

export const getLevelTitle = (level: number) => {
    if (level === 3) {
        return "Avansat";
    } else if (level === 2) {
        return "Consolidat";
    } else {
        return "De bază";
    }
}

export const getLevelTitleColor = (level: number, isText: boolean) => {
    if (level === 3) {
        return isText ? "#065F46" : "#059669";
    } else if (level === 2) {
        return isText ? "#00289B" : "#0064FF";
    } else {
        return isText ? "#777777" : "#94A3B8";
    }
}

export const getLevelColor = (score: number, isText: boolean) => {
    if (score >= 9) {
        return "#059669";
    } else if (score >= 7) {
        return "#0064FF";
    } else if (score >= 5){
        return isText ? "#777777" : "#94A3B8";
    } else {
        return "#DE6525";
    }
}

export const getLevelBgColor = (score: number) => {
    if (score >= 9) {
        return "#ecfdf5";
    } else if (score >= 7) {
        return "#D7E6FF";
    } else if (score >= 5){
        return "#f5f5f5";
    } else {
        return "#FFFBEB";
    }
}

export const getEmpathyText = (score: number, items: any[]) => {
    const hasCorrectAnswers = items.some(item => item.answer === "corect");

    if(score <= 2.99) {
        return hasCorrectAnswers ? texteReport.texte.empathy.dificultate.banda1.cu_corecte : texteReport.texte.empathy.dificultate.banda1.fara_corecte;
    } else if (score >= 3 && score <= 3.99) {
        return hasCorrectAnswers ? texteReport.texte.empathy.dificultate.banda2.cu_corecte : texteReport.texte.empathy.dificultate.banda2.fara_corecte;
    } else if (score >= 4 && score <= 4.99) {
        return hasCorrectAnswers ? texteReport.texte.empathy.dificultate.banda3.cu_corecte : texteReport.texte.empathy.dificultate.banda1.fara_corecte;
    } else if (score >= 5 && score <= 5.99) {
        return texteReport.texte.empathy.baza.banda1;
    } else if (score >= 6 && score <= 6.49) {
        return texteReport.texte.empathy.baza.banda2;
    } else if (score >= 6.5 && score <= 6.99) {
        return texteReport.texte.empathy.baza.banda3;
    } else if (score >= 7 && score <= 7.99) {
        return texteReport.texte.empathy.consolidat.banda3;
    } else if (score >= 8 && score <= 8.49) {
        return texteReport.texte.empathy.consolidat.banda3;
    } else if (score >= 8.5 && score <= 8.99) {
        return texteReport.texte.empathy.consolidat.banda3;
    } else if (score >= 9 && score <= 9.49) {
        return texteReport.texte.empathy.avansat.banda3;
    } else if (score >= 9.5 && score <= 9.74) {
        return texteReport.texte.empathy.avansat.banda3;
    } else if (score >= 9.75 && score <= 10) {
        return texteReport.texte.empathy.avansat.banda3;
    }
}

export const getAnswerBoxColor = (answerType: string) => {
    switch (answerType) {
        case "corect":
            return "success.main";
        case "gresit":
            return "error.light";
        case "din_neatentie":
            return "warning.main";
        default:
            return "chart.color9";
    }
}

export const getSubcategories = (students: Student[]) => {
    return Array.from(
        new Set(
            students.flatMap((student) =>
                student.subcategories.map((sub) => sub.subcategory_name)
            )
        ))
}

export const getStudentsLastName = (name: string) => {
    let values = name.split(" ");
    let lastName = values[values.length - 1];
    return (lastName);

}

// Sort students by name alphabetically
export const sortStudents = (students: Student[]) => {
    return students.sort((a: Student, b: Student) => getStudentsLastName(a.student_name).localeCompare(getStudentsLastName(b.student_name)));
}
export const calculateTableRows = (
    students: Student[],
    subcategories: string[],
    isStandardTReport: boolean
): TableRow[] => {
    const threshold = isStandardTReport ? 5 : 50;

    return subcategories.map((subcategory: string) => {
        // 1. Identify and extract qualifying students with their specific score for this dimension
        const qualifyingStudents: { name: string; score: number }[] = [];

        students.forEach((student) => {
            const matchingSubcategory = student.subcategories?.find(
                (sub) => sub.subcategory_name === subcategory
            );

            if (matchingSubcategory && matchingSubcategory.subcategory_score <= threshold) {
                qualifyingStudents.push({
                    name: student.student_name,
                    score: matchingSubcategory.subcategory_score,
                });
            }
        });

        // 2. Sort by score ascending (students needing the most help appear first)
        qualifyingStudents.sort((a, b) => a.score - b.score);

        // 3. Return cleanly structured table row data
        return {
            dimensions: subcategory,
            students_number: qualifyingStudents.length,
            students: qualifyingStudents.map((item) => item.name),
            studentScore: qualifyingStudents.map((item) => item.score),
        };
    });
};